// This file generates a nonce, which is a random string used in OAuth flows to prevent replay attacks.
// It is typically used in conjunction with a code challenge to ensure the integrity of the authentication process.
export function generateNonce(length: number = 32) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let nonce = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    nonce += characters.charAt(randomIndex);
  }
  return nonce;
}
